var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lines-container"},[_c('svg',{class:[
      'lines-icon',
      _vm.isButtonActive ? 'active-color' : 'inactive-color'
    ],attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 24 24","fill":"none","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('line',{attrs:{"x1":"3","x2":"21","y1":"6","y2":"6"}}),_c('line',{attrs:{"x1":"3","x2":"21","y1":"12","y2":"12"}}),_c('line',{attrs:{"x1":"3","x2":"21","y1":"18","y2":"18"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }